module.exports = {"name":"Článok s hlavičkou"}


//////////////////
// WEBPACK FOOTER
// ./src/templates/article-header/article-header.json
// module id = 415
// module chunks = 0